import React, { useState, useEffect, useContext } from 'react';
import '../css/contact.css';
import { Container, Col, Row, Form, Button, Alert } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import PropTypes from 'prop-types';
import endpoints from '../constants/endpoints';
import FallbackSpinner from './FallbackSpinner';
import AppContext from '../AppContext';
import { getTranslation } from '../constants/translations';

const styles = {
  introImageContainer: {
    margin: '0 auto',
    textAlign: 'center',
  },
};

function Contact({ title }) {
  const { language } = useContext(AppContext);
  const t = getTranslation(language).contact;
  const [data, setData] = useState(null);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    phone: '',
    message: '',
  });
  const [messageStatus, setMessageStatus] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Pour suivre l'état du bouton

  useEffect(() => {
    fetch(endpoints.contact, {
      method: 'GET',
    })
      .then((res) => res.json())
      .then((res) => setData(res))
      .catch((err) => console.error(err));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Désactiver le bouton
    try {
      
      const response = await fetch(endpoints.sendEmail, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setMessageStatus('success');
        setFormData({
          firstName: '',
          lastName: '',
          companyName: '',
          email: '',
          phone: '',
          message: '',
        });
      } else {
        setMessageStatus('error');
        console.error('Error sending email:', response.statusText);
      }
    } catch (error) {
      setMessageStatus('error');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false); // Réactiver le bouton
    }
  };

  return (
    <Fade bottom>
      
      <div className="header-container">
      <h1>{title || t.title}</h1>
    </div>
      
        <Container>
          {messageStatus === 'success' && (
            <Alert variant="success">{t.success}</Alert>
          )}
          {messageStatus === 'error' && (
            <Alert variant="danger">{t.error}</Alert>
          )}

          {data ? (
            <>
              <Row>
                
                <Col style={styles.introImageContainer}>
                
                  <img src={data?.imageSource} alt="Contact" width="30%" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="firstName">
                      <Form.Label>{t.firstName}</Form.Label>
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group controlId="lastName">
                      <Form.Label>{t.lastName}</Form.Label>
                      <Form.Control
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group controlId="companyName">
                      <Form.Label>{t.companyName}</Form.Label>
                      <Form.Control
                        type="text"
                        name="companyName"
                        value={formData.companyName}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                    <Form.Group controlId="email">
                      <Form.Label>{t.email}</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </Form.Group>
                    <Form.Group controlId="phone">
                      <Form.Label>{t.phone}</Form.Label>
                      <Form.Control
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                      />
                    </Form.Group>
                    <Form.Group controlId="message" style={{ marginBottom: '20px' }}>
                      <Form.Label>{t.message}</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows={4}
                        required
                      />
                    </Form.Group>
                    <Button
                      type="submit"
                      disabled={isSubmitting} // Désactive le bouton
                    >
                      {isSubmitting ? t.sending : t.send}
                    </Button>
                  </Form>
                </Col>
              </Row>
            </>
          ) : (
            <FallbackSpinner />
          )}
        </Container>
    
    </Fade>
  );
}

Contact.propTypes = {
  title: PropTypes.string,
};

Contact.defaultProps = {
  title: undefined,
};

export default Contact;
